import { agencyActions } from '../actionTypes';
import {
  _insertRecord,
} from '../utils';
import createLogger from '../../utils/createLogger';

const DEBUG = true;
const debug = createLogger(DEBUG, `agenciesReducer.js`);

/* -------- initial state -------- */
const initialState = {agencies: []};

export default (state = initialState, action) => {
  switch (action.type) {

    /* -------- titles api -------- */

    /* -------- get titles -------- */
    case agencyActions.GET_AGENCIES_REQUEST:
      return state;

    case agencyActions.GET_AGENCIES_FAILURE:
      return state;

    case agencyActions.GET_AGENCIES_SUCCESS:
      if (action.data) {
        debug.log(' get_agencies_success');
        debug.log(action.data);
        return {...state, agencies: action.data}
      }
      return state;


    /* -------- delete agency -------- */

    case agencyActions.DELETE_AGENCY_SUCCESS:
      if (action.data) {
        return {...state, agencies: state.agencies.filter(object => object._id !== action.data)};
      }
      return state;


    /* -------- post agency -------- */
    case agencyActions.POST_AGENCY_SUCCESS:
      if (action.data) {
        debug.log('action.data:');
        debug.log(action.data);
        return {...state, agencies: [...state.agencies, {...action.data}]};
      }
      return state;


    /* -------- put agency -------- */
    case agencyActions.PUT_AGENCY_SUCCESS:
      if (action.data) {
        let newState = {...state, agencies: [...state.agencies]};
        _insertRecord(newState.agencies, action.data);
        return newState;
      }
      return state;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/data/agencies/agenciesReducer.js